import ApiClient from '@/utils/apiClient'

import type { AxiosResponse } from 'axios'
import type { Placement } from '@/types/placement'

class PlacementService {
    apiClient: any
    constructor() {
        this.apiClient = new ApiClient(import.meta.env.VITE_DX_API_URL)
    }

    getPlacements = async (bpId: number | null): Promise<Placement[]> => {
        const response: AxiosResponse = await this.apiClient.get(
          `businessProfiles/${bpId}/PublishedTemplateConfigurations`);
        const parsedConfigurations = response.data.map((config: any) => {
            const guidelines = JSON.parse(config.creativeSetGuidelines);
            return {
                ...config,
                creativeSetConfiguration: guidelines.CreativeSetConfiguration,
                creativeSetGuidelines: guidelines.ValidationGuidelines,
                publishedVariants: config.publishedVariants.map((variant: any) => ({
                    id: variant.id,
                    canvasJson: JSON.parse(variant.canvasJson)
                }))
            };
        });

        return parsedConfigurations;
    }
}

export default PlacementService
